<template>
	<page>
		<module title="基本信息" height="auto">
			<c-detail >
				<c-detail-item label="类型" >
					<span v-if="orderDetail.order_type==10" style="color:blue">充值升级</span>
					<span v-else-if="orderDetail.order_type==11" style="color:#ff00ff">货款充值</span>
					<span v-else>销售订单</span>
				</c-detail-item>
				<c-detail-item label="销售方式" >
					<span v-if="orderDetail.order_classify==1" style="color:green">供货</span>
					<span v-else-if="orderDetail.order_classify==2" style="color:#0000ff">直销</span>
					<span v-else>-</span>
				</c-detail-item>
				<c-detail-item label="业务单号" >
					{{orderDetail.order_number}}
				</c-detail-item>
				<c-detail-item label="下单时间" >
					{{orderDetail.create_date}}
				</c-detail-item>
				<c-detail-item label="支付时间" >
					{{orderDetail.payment_date||'--'}}
				</c-detail-item>
				<c-detail-item label="实付金额(不计运费)" >
					￥{{parseFloat(orderDetail.payment_money).toFixed(2)}}
				</c-detail-item>
                <c-detail-item label="下单用户" full>
                    {{orderDetail.nick_name}}【{{orderDetail.user_manage_mobilephone}}】
                </c-detail-item>
			</c-detail>
		</module>
		
		<module title="清分信息">
			<div style="padding: 30px 30px 40px;">
				<c-table v-model="rewardRecordList" height="auto" :paging="false" border>
					<c-table-column
						label="奖励用户"
						name="reward_nick_name"
						width="230"
					>
						<template v-slot="{data}">
							{{data.reward_nick_name}}【{{data.reward_user_manage_mobilephone}}】
						</template>
					</c-table-column>
					
					<c-table-column
						label="奖励用户等级"
						name="user_level_name"
						width="100"
					>
						<template v-slot="{data}">
							{{data.user_level_name}}
						</template>
					</c-table-column>

					<!-- <c-table-column
						label="清分类型"
						name="reward_type"
						width="100"
					>
						<template v-slot="{data}">
							<span v-if="data.reward_type == 6" style="color:#999"> {{rewardTypeName[data.reward_type]}} </span>
							<span v-else> {{rewardTypeName[data.reward_type]||'其他'}} </span>
						</template>
					</c-table-column> -->

					<c-table-column
						label="清分金额"
						name="record_money"
						width="80"
					>
						<template v-slot="{data}">
							<span v-if="data.state==2" style="color: green">{{'¥'+parseFloat(data.record_money).toFixed(2)}}</span>
							<span v-else>{{'¥'+parseFloat(data.estimated_record_money).toFixed(2)}}</span>

						</template>
					</c-table-column>

					<c-table-column
						label="奖励状态"
						name="state"
						width="70"
					>
						<template v-slot="{data}">
							<span v-if="data.state == 0" style="color:darkgray"> {{stateName[data.state]}} </span>
							<span v-else-if="data.state == 1" style="color:#2348d0"> {{stateName[data.state]}} </span>
							<span v-else-if="data.state == 2" style="color:darkgreen"> {{stateName[data.state]}} </span>
							<span v-else> {{stateName[data.state]}} </span>
						</template>
					</c-table-column>

					<c-table-column
						label="创建时间"
						name="create_date"
						width="140"
					></c-table-column>

					<c-table-column
						label="清分结算时间"
						name="settlement_date"
						width="140"
					>
						<template v-slot="row">
							{{row.data.settlement_date||'-'}}
						</template>
					</c-table-column>

					<c-table-column
						label="下单用户"
						name="nick_name"
						width="260"
					>
						<template v-slot="{data}">
							{{data.nick_name}}【<font color="#999">{{data.user_manage_mobilephone}}</font>】
						</template>
					</c-table-column>

					<c-table-column
						label="下单用户等级"
						name="level_name"
						width="100"
					>
						<template v-slot="{data}">
							{{data.level_name||'-'}}
						</template>
					</c-table-column>
					
					<!-- <c-table-column
						label="供货订单号"
						name="sub_order_number"
						width="130"
					>
						<template v-slot="{data}">
							{{data.sub_order_number||'-'}}
						</template>
					</c-table-column> -->
					
					<c-table-column
						label="备注说明"
						name="remark"
						width="260"
					>
						<template v-slot="{data}">
							{{data.remark||'-'}}
						</template>
					</c-table-column>
					
					<c-table-column
						type="button"
						fixed="right"
						label="操作"
						width="100"
					>
						<template v-slot="{data}">
							<c-table-button @click="rejected(data)" v-if="data.state == 1 ">取消结算</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</div>
		</module>
		
		<c-dialog ref="rejectedReason" title="取消原因" width="400" @resolve="rejectedHandle">
			<div class="rejected-eason">
				<textarea v-model="rejectedReason" placeholder="请输入取消结算原因..."></textarea>
			</div>
		</c-dialog>
		

	</page>
</template>

<script>
	export default {
		name: 'order_reward_record_detail',
		props: {
			orderNumber: String
		},
		data() {
			return {
				stateName: {
					0: '取消清分',
					1: '待清分',
					2: '已经清分'
				},
				rewardTypeName: {
					1: '零售收益',
					2: '分享补贴',
					3: '辅助分享补贴',
					// 4: '下单奖励',
					// 5: '辅助下单奖励',
					6: '解冻金额',
					//7: '进货补贴',
					//8: '辅助进货补贴'
					9: '区代奖励',
					10: '销售奖励',
					11: '分红奖励'
				},
				orderDetail: {},
				rewardRecordList: [],
				rejectedReason: '',
			}
		},
		watch:{//ID变更刷新页面
			orderNumber(){
				this.detail();
			}
		},
		mounted() {
			this.detail();
		},
		computed: {

		},
		methods: {
			detail() {
				this.request({
					url: '/reward/record/detail',
					data: {order_number: this.orderNumber},
					loading: true,
					success: data => {
						this.orderDetail = data.order_info;
						this.rewardRecordList = data.reward_records;
					}
				});
			},
			//驳回弹框
			rejected(data) {
				this.t_data = data;
				this.$refs.rejectedReason.open();
			},
			//取消驳回提交
			rejectedHandle(stop){
				
				if (!this.rejectedReason.trim()) {
					this.$message({
						text: '请填写取消结算原因'
					});
					stop();
					return;
				}
				this.request({
					url: '/reward/record/cancel',
					data: {id:this.t_data.id,reject_reason:this.rejectedReason.trim()},
					loading: true,
					success: data => {
						this.$message({
							text: '取消结算成功',
							icon: 'success'
						});
						this.t_data.state = 0;
						this.t_data.remark = this.rejectedReason.trim();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.rejected-eason {
		padding: 20px;
		
		textarea {
			box-sizing: border-box;
			width: 100%;
			height: 120px;
			border: none;
			padding: 10px 14px;
			line-height: 20px;
			background: #FAFAFA;
			resize: none;
		}
	}
</style>